<template>

	<table class="table table-sm table-bordered table-striped">
		<thead  style="position: sticky; top: 0">
			<tr class="head">
				<td>Fecha</td>
				<td>Estado</td>
			</tr>
		</thead>
		<tbody>
			<tr v-for="sc in cambiosEstados" :key="sc.id">
				<td>{{sc.fecha.date.split('.')[0] }}</td>
				<td>{{sc.nombre}}</td>
			</tr>
			<tr v-if="cambiosEstados.length === 0">
				<td colspan="2" style="text-align: center;">
					No se encontró información del cambio de estado en seller center.
				</td>
			</tr>
		</tbody>
	</table>

</template>

<script>

    export default {
        props: {
          cambiosEstados: {
            required: true
            },
          },
        name:"cambiosestados",
       
    }
</script>

<style scoped>
	td {
		font-weight: 500 !important;
	}
</style>
